import React, { createContext, useContext } from "react";
import { useFetchNew } from "../data/fetch/useFetch";
import { getConfiguration, getTimezoneOffset } from "../data/utils";
import { parseTimelineData } from "../data/parseTimelineData";
import Loader from "./Loader";

export const NavButtonsContext = createContext(null);

export function useNavButtons() {
    return useContext(NavButtonsContext);
}

export default function NavButtonsProvider(props) {
    const conf = getConfiguration();
    const [isLoading, isError, data] = useFetchNew(conf.api.getTimelinePalinsestiDelGiorno, { timezone: getTimezoneOffset() }, (data) =>
        parseTimelineData(data)
    );

    if (isLoading || isError) {
        return <Loader error={isError} />
    }

    return (
        <NavButtonsContext.Provider value={data.weekDays}>
            {props.children}
        </NavButtonsContext.Provider>
    );
}
